module.exports = "pegasus_template/assets/circle-linkedin.png";